import React, { Component } from "react";
import Swal from "sweetalert2";
import { format } from "date-fns";

class ModalAsignacion extends Component {
  render() {
    return (
        <div id="asignarMetas">
          <fieldset className="panel">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Departamento:</label>
                    <span className="text-danger"> *</span>
                    <select
                      onChange={(e) =>
                        this.props.component.handleChangeAsignacion(e)
                      }
                      name="departamento_id"
                      id="departamento_id"
                      className="form-control m-b-5"
                      value={this.props.state.asignar.departamento_id}
                    >
                      <option className="dropdown-item">
                        {" "}
                        -- Seleccione --
                      </option>
                      {this.props.state.locations.departamentos.map(
                        (option, index) => (
                          <option
                            key={index}
                            className="dropdown-item"
                            value={option.id}
                          >
                            {option.name}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Municipio: </label>
                    <span className="text-danger"> *</span>
                    <select
                      onChange={(e) =>
                        this.props.component.handleChangeAsignacion(e)
                      }
                      name="municipio_id"
                      id="municipio_id"
                      className="form-control"
                      value={this.props.state.asignar.municipio_id}
                    >
                      <option className="dropdown-item">
                        {" "}
                        -- Seleccione --
                      </option>
                      {this.props.state.locations.municipios
                        .filter(
                          (e) =>
                            e.estado_id === this.props.state.asignar.departamento_id
                        )
                        .map((option) => (
                          <option className="dropdown-item" value={option.id}>
                            {option.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>
                      Seleccione especialista:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="especialista_id"
                      id="especialista_id"
                      onChange={(e) =>
                        this.props.component.handleChangeAsignacion(e)
                      }
                      value={this.props.state.asignar.especialista_id}
                      className="form-control"
                      required
                      disabled={this.props.state.acceso === 2 ? false : true}
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.options_especialistas.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>
                      Seleccione meta: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="meta_poa_id"
                      id="meta_poa_id"
                      onChange={(e) =>
                        this.props.component.handleChangeAsignacion(e)
                      }
                      value={this.props.state.asignar.meta_poa_id}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.options_metas.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.codigo} - {option.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label> Cantidad programada:<span className="text-danger"> *</span> </label>
                    <input
                      type="text"
                      name="cantidad"
                      id="cantidad"
                      onChange={this.props.component.handleChangeAsignacion}
                      value={this.props.state.asignar.cantidad}
                      required
                      className="form-control"
                      maxLength={4}
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="form-group">
                    <label>
                      Mes: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="mes"
                      id="mes_id"
                      onChange={(e) =>
                        this.props.component.handleChangeAsignacion(e)
                      }
                      value={this.props.state.asignar.mes}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.options_mes.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.mes}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group">
                    <div className="form-check" style={{ margin: 25 }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="anio"
                        id="anio"
                        onChange={this.props.component.handleChangeAsignacion}
                        value={this.props.state.asignar.anio || false}
                        checked={this.props.state.asignar.anio || false}
                      />
                      <label className="form-check-label">Año completo</label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <button
                    type="button"
                    onClick={(e) => this.props.component.addAsignacion(e)}
                    className="btn btn-success float-right"
                    name="add"
                    id="add"
                  >
                    Asignar
                  </button>
                </div>
              </div>
            </div>
            {/**tabla */}
            <hr></hr>
            <div className="table-responsive">
              <table className="table table-striped m-b-0 table-hover">
                <thead>
                  <tr>
                    <th className="text-center">Nombre</th>
                    <th className="text-center">Meta</th>
                    <th className="text-center">Cantidad</th>
                    <th className="text-center">Departamento</th>
                    <th className="text-center">Municipio</th>
                    <th className="text-center">Mes</th>
                    <th className="text-center">Fecha inicio</th>
                    <th className="text-center">Fecha final</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.state.asignaciones.length  !== 0 ? (
                    this.props.state.asignaciones.map((asignacion, index) => (
                      <tr key={index} id={index}>
                        <td className="text-center">{asignacion.nombre}</td>
                        <td
                          className="text-center"
                          data-toggle="tooltip"
                          data-placement="top"
                        >
                          {asignacion.descripcion_meta}
                        </td>
                        <td className="text-center">{asignacion.cantidad}</td>
                        <td className="text-center">
                          {asignacion.departamento}
                        </td>
                        <td className="text-center">{asignacion.municipio}</td>
                        <td className="text-center">{asignacion.mes_nom}</td>
                        <td className="text-center">
                          {
                           format(
                            new Date(asignacion.fecha_inicio),
                            "dd/MM/yyyy"
                           )}
                        </td>
                        <td className="text-center">
                          {
                           format(
                            new Date(asignacion.fecha_final),
                            "dd/MM/yyyy"
                           )}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-warning remover-sancion"
                            id={index}
                            onClick={this.props.component.removeAsignacion}
                          >
                            <i
                              className="fas fa-trash"
                              id={index}
                              onClick={this.props.component.removeAsignacion}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-center">No hay asignaciones</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </fieldset>

          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModal(2);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="button"
              className="btn btn-success btn-block"
              onClick={(e) => {
                this.props.component.handleSubmit(e, 2);
              }}
            >
              Aceptar
            </button>
          </div>
        </div>
    );
  }
}

export default ModalAsignacion;
